/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 public/models/train.glb -T -o src/components-3d/Train.jsx 
Files: public/models/train.glb [83.02KB] > C:\Users\tarbl\Documents\Software Dev\!Projects\three.js-personal-website\src\components-3d\train-transformed.glb [41.41KB] (50%)
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'
import { useSmartTexture } from '../hooks/useSmartTexture.js'

export function Train(props) {
  const { nodes } = useGLTF('/models/train.glb')
  
  const bakedTexture = useSmartTexture('train')
  bakedTexture.flipY = false

  return (
    <group {...props} dispose={null} scale = {100}>
      <mesh geometry={nodes.train.geometry} material={nodes.train.material}>
        <meshBasicMaterial map={bakedTexture} />
      </mesh>
    </group>
  )
}

useGLTF.preload('/models/train.glb')
